var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCervical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9202 20.7854C15.2202 19.1054 15.2002 18.2854 15.1102 17.8654C15.0802 17.7154 15.2102 17.5954 15.3602 17.6454C16.0202 17.8854 16.7102 17.8254 17.2402 17.4654C17.6402 17.1954 18.0802 16.8754 18.4102 16.1954C18.8402 16.0754 19.2302 15.8854 19.5802 15.6154C19.6102 15.5954 19.6402 15.5754 19.6702 15.5554C19.6802 15.5554 19.6902 15.5354 19.7002 15.5354C20.0902 15.2554 20.4002 14.9054 20.6302 14.5154C21.1102 13.7354 21.1002 12.8554 20.7702 12.0454C21.3802 10.9754 21.4102 9.63536 20.9102 8.52536C20.8602 8.41536 20.8102 8.30536 20.7502 8.19536C21.1702 7.39536 21.2702 6.48536 20.9702 5.62536C20.1302 3.62536 18.2802 3.03536 16.5702 3.59536C16.1902 3.35536 15.7602 3.18536 15.2902 3.09536C14.2802 2.86536 13.2602 3.06536 12.4302 3.54536C11.2902 3.14536 9.9502 3.38536 8.8402 4.13536C7.3202 3.47536 5.77019 3.82536 4.77019 5.20536C4.24019 6.00536 4.32018 6.98536 4.82018 7.75536C4.35018 8.15536 4.04017 8.70536 4.00017 9.25536C3.99017 9.86536 4.41016 10.4554 4.98016 10.8354C4.47016 11.2654 4.18016 11.9054 4.30016 12.5154C4.38016 12.8254 4.72016 13.4954 4.98016 13.6954C5.16016 13.8354 5.23018 14.0854 5.19018 14.3154C5.14018 14.6154 5.06018 15.3554 5.07018 15.5754",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2207 15.6158C7.3307 14.5658 7.34069 14.4758 7.46069 13.9158C8.67069 13.4458 9.23068 11.4258 8.13068 10.5458C8.13068 10.5458 8.11066 10.5358 8.11066 10.5258C8.32066 10.2258 8.4707 9.89582 8.5307 9.54582C8.5807 9.31582 8.5807 9.07582 8.5307 8.84582C9.2107 8.58582 9.74068 8.05582 9.95068 7.40582C10.7007 7.50582 11.5507 7.51582 12.4607 7.07582C12.5107 7.04582 12.5507 7.00582 12.6007 6.96582C12.8107 7.09582 13.0307 7.21582 13.2707 7.29582C14.0507 7.66582 15.0007 7.64582 15.7807 7.31582C16.0607 7.62582 16.3807 7.90582 16.7407 8.12582C16.8107 8.16582 16.8807 8.19582 16.9507 8.23582C16.7207 8.73582 16.5707 9.26582 16.5307 9.81582C16.5107 10.3458 16.6907 10.8658 16.9907 11.3258C16.6007 11.6658 16.3507 12.1258 16.2107 12.6158C16.1907 12.6958 16.2606 12.5058 16.2906 12.4558C16.1506 12.7558 16.1007 13.0958 16.1307 13.4258C15.4907 13.6358 14.9007 13.9658 14.4907 14.4258C13.8407 13.8558 12.6507 13.9958 11.9907 14.5158C11.2607 15.0158 10.7607 16.3758 11.5207 18.1558C11.9607 19.2058 12.4807 19.6858 12.3907 20.7758",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6602 10.5449C14.7202 10.5749 14.8401 10.6249 14.7301 10.5549",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6309 11.4355C12.8509 11.7355 13.2009 12.1655 13.6609 12.3655",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4805 12.3955C10.6305 13.3055 12.2305 13.6355 12.2805 14.2655",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9111 9.52548C12.0511 9.12548 10.5711 9.41548 10.6411 10.3955",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCervical);
export default __webpack_public_path__ + "static/media/Cervical.65c4ff4174b43a32f32b1190b85f43ec.svg";
export { ForwardRef as ReactComponent };